var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4324_36513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2652 17.0547C32.2652 8.16978 25.2383 0.967163 16.5701 0.967163C7.90195 0.967163 0.875 8.16978 0.875 17.0547C0.875 25.9395 7.90195 33.1422 16.5701 33.1422C25.2383 33.1422 32.2652 25.9395 32.2652 17.0547Z",
    fill: "#ECECF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1134 21.1125V23.0342C23.1141 23.2126 23.0766 23.3892 23.0034 23.5526C22.9303 23.7162 22.823 23.8629 22.6884 23.9836C22.5538 24.1041 22.395 24.1959 22.2219 24.2532C22.0489 24.3102 21.8656 24.3315 21.6837 24.3155C19.6655 24.1013 17.7271 23.4277 16.0239 22.3488C14.4394 21.3653 13.0959 20.053 12.089 18.5052C10.9806 16.834 10.2909 14.9313 10.0757 12.9512C10.0592 12.7741 10.0808 12.5956 10.1389 12.427C10.197 12.2584 10.2905 12.1036 10.4132 11.9722C10.536 11.8408 10.6854 11.7358 10.852 11.664C11.0186 11.5921 11.1986 11.5549 11.3807 11.5547H13.3482C13.6665 11.5517 13.975 11.6618 14.2163 11.8645C14.4576 12.0672 14.6152 12.3487 14.6598 12.6566C14.7429 13.2716 14.8969 13.8755 15.1189 14.4566C15.2071 14.6859 15.2262 14.9351 15.1739 15.1747C15.1216 15.4142 15.0001 15.6341 14.8237 15.8083L13.9909 16.6219C14.9244 18.2256 16.2839 19.5535 17.9257 20.4655L18.7586 19.6518C18.937 19.4796 19.1622 19.361 19.4074 19.3098C19.6526 19.2588 19.9078 19.2775 20.1424 19.3636C20.7375 19.5805 21.3557 19.7309 21.9854 19.812C22.3039 19.856 22.5949 20.0126 22.8028 20.2524C23.0108 20.4922 23.1214 20.7983 23.1134 21.1125Z",
    stroke: "#0E1318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4324_36513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.0703125 0.554688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.5d60b657539a61b86714b0073eef5a85.svg";
export { ForwardRef as ReactComponent };